import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import ALink from '../../common/ALink';
import useTranslation from '../../../utils/hooks/useTranslation';

function BlogCard({ adClass = '', blog }) {
    const { t } = useTranslation();
    const date = new Date(blog.updated_at);
    const monthArray = [
        t('label.jan'), t('label.feb'), t('label.mar'),
        t('label.apr'), t('label.may'), t('label.jun'),
        t('label.jul'), t('label.aug'), t('label.sep'),
        t('label.oct'), t('label.nov'), t('label.dev')
    ];
    const day = date.getUTCDate() < 10 ? `0${date.getUTCDate()}` : date.getUTCDate();
    const formattedDate = `${monthArray[date.getUTCMonth()]} ${day}, ${date.getUTCFullYear()}`;

    return (
        <article className={`blog-card ${adClass}`}>
            <ALink href={`/blog/${blog.id}`} className="blog-card-media" aria-label={blog.title}>
                <figure>
                    <LazyLoadImage
                        alt={blog.title}
                        src={process.env.REACT_APP_PUBLIC_ASSET_URI + blog.image.url}
                        threshold={500}
                        width="100%"
                        height="100%"
                        effect="opacity"
                    />
                </figure>
                {blog.video && (
                    <span className="blog-card-play" aria-hidden="true">
                        <i className="fas fa-play" />
                    </span>
                )}
            </ALink>

            <div className="blog-card-body">
                <div className="blog-card-meta">
                    <time dateTime={date.toISOString()}>{formattedDate}</time>
                    <span className="blog-card-dot" />
                    <span>{t('message.article')}</span>
                </div>

                <h3 className="blog-card-title">
                    <ALink href={`/blog/${blog.id}`}>{blog.title}</ALink>
                </h3>

                <p className="blog-card-excerpt">{blog.short_description}</p>

                <ALink href={`/blog/${blog.id}`} className="blog-card-read" aria-label={`${t('message.read_more')}: ${blog.title}`}>
                    {t('message.read_more')}
                    <i className="icon-angle-right" />
                </ALink>
            </div>
        </article>
    );
}

export default BlogCard;
